
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import moment from 'moment';

import {classesApi} from '@/api';
import formHelper from '../../../js/account/account.helper';

Vue.prototype.moment = moment;
@Component({
    components: {}
})
export default class New_Student extends Vue {
    @Prop({default: []}) editStudent?: any;
    @Prop({default: ''}) studentType?: string;
    @Emit('closeModal') private closeModal() {}
    @Emit('refreshStudentList') private refreshStudentList() {}
    @Emit('newAgain') private newAgain() {}

    //===================================data区域begin
    checkNickName = (rule: any, value: any, callback: any) => {
        if (value) {
            if (!/[a-zA-Z0-9_\u4e00-\u9fa5- _.~!@#\$%\^&\*\(\)\+=\|\\\}\]\{\[:;<,>\?\/""]*/g.test(value)) {
                callback(new Error('仅支持中/英文、数字和下划线或其他符号'));
            } else {
                if (this.fail.nickName) {
                    callback(new Error('该姓名已存在，请输入其他姓名'));
                } else {
                    callback();
                }
            }
        }
        callback();
    };
    checkSpecial = (rule: any, value: any, callback: any) => {
        if (value) {
            if (!/^[0-9a-zA-Z_]{1,}$/g.test(value)) {
                callback(new Error('仅支持英文、数字和下划线'));
            } else {
                if (this.fail.userName) {
                    callback(new Error('该账号已存在，请输入其他账号'));
                } else {
                    callback();
                }
            }
        }
        callback();
    };
    // 密码输入框不支持中文的验证规则
    changeKey = function(rule: any, value: any, callback: any) {
        if (value === '') {
            callback();
        }
        //定义你需要的正则
        let rgx = /^(?!_)(?!.*?_$)[a-zA-Z0-9_]+$/;
        if (rgx.test(value)) {
            //验证通过调用回调函数
            callback();
        } else {
            callback(new Error('只允许包含数字、字母、下划线'));
        }
    };
    // 密码输入框不少于6位
    checkLength = function(rule: any, value: any, callback: any) {
        if (value === '') {
            callback();
        }
        if (value.length < 6) {
            callback(new Error('请输入不少于6位的密码'));
        }
        if (value.length > 30) {
            callback(new Error('最大长度30个字符'));
        } else {
            callback();
        }
    };

    checkNumber = function(rule: any, value: any, callback: any) {
        if (value) {
            if (/^\d+$/g.test(value)) {
                callback(new Error(' 不可输入纯数字作为账号'));
            } else {
                callback();
            }
        }
        callback();
    };
    formStudent: any = formHelper.newStudentForm;
    formRulesStudent: any = {
        username: [
            {
                required: true,
                message: '请输入账号',
                trigger: 'blur'
            },
            {validator: this.checkNumber, trigger: 'blur'},
            {validator: this.checkSpecial, trigger: 'blur'},
            {max: 27, message: '最大长度27个字符', trigger: 'blur'}
        ],
        sex: [
            {
                required: true,
                message: '请选择性别',
                trigger: 'blur'
            }
        ],
        nickname: [
            {
                required: true,
                message: '请输入学生姓名',
                trigger: 'blur'
            },
            {validator: this.checkNickName, trigger: 'blur'},
            {max: 20, message: '最大长度20个字符', trigger: 'blur'}
        ],
        password: [
            {
                required: true,
                message: '请输入登录密码',
                trigger: 'blur'
            },
            {validator: this.changeKey, trigger: 'blur'},
            {validator: this.checkLength, trigger: 'blur'}
        ],
        period: [
            {
                required: true,
                message: '请选择学段',
                trigger: 'change'
            }
        ],
        grade: [
            {
                required: true,
                message: '请选择年级',
                trigger: 'change'
            }
        ],
        classId: [
            {
                required: true,
                message: '请输入班级名称',
                trigger: 'change'
            }
        ],
        validStartTime: [
            {
                required: true,
                message: '请选择有效期',
                trigger: 'change'
            }
        ]
    };
    // 新建教师表单学校有效期
    schoolValidityStart: string = '';
    schoolValidityEnd: string = '';
    // 新建或编辑教师有效期选择组件是否显示
    isSchoolValidity: boolean = true;
    // 编辑学生是否过期
    isOverdueStudent: boolean = false;
    fail = {
        nickName: false,
        userName: false
    };
    //===================================data区域end
    //===================================computed区域begin
    isNewStudent() {
        return this.studentType === '新增';
    }
    //===================================computed区域end
    //===================================methods区域begin
    // 清空表单数据
    refreshForm() {
        this.isOverdueStudent = false;
        this.formStudent.nickname = '';
        this.formStudent.sex = undefined;
        this.formStudent.username = '';
        this.formStudent.password = '';
        // this.formStudent.mobile = '';
        this.formStudent.validStartTime = '';
        this.formStudent.expireTime = '';
        this.formStudent._id = '';
    }
    handleCancel() {
        this.refreshForm();
        this.$emit('closeModal');
    }
    handleSave(flag: any) {
        // console.log(this.formStudent);
        let isValid = false;
        let me = this;
        me.fail.nickName = false;
        me.fail.userName = false;
        (me.$refs.studentForm as any).validate((valid: any) => {
            if (!valid) {
                return;
            }
            isValid = true;
            if (isValid) {
                let form: any = JSON.parse(JSON.stringify(me.formStudent));
                if (form.sex == 'null') {
                    form.sex = null;
                }
                if (me.studentType == '班级管理-新增' || me.studentType == '班级管理-编辑') {
                    form.period = me.editStudent.period;
                    form.grade = me.editStudent.grade;
                    form.classId = me.editStudent.classId;
                }
                classesApi.saveStudent({
                    context: me,
                    data: form,
                    success(data: any, parameters: any) {
                        me.$message.success('恭喜你，操作成功！');
                        me.$emit('refreshStudentList');
                        me.handleCancel();

                        if (flag == 'again') {
                            me.$emit('newAgain');
                        }
                    },
                    error(error: any, message: string, parameters: any) {
                        if (error.code === 90015) {
                            me.fail.nickName = true;
                        }
                        if (message === '用户已存在') {
                            me.fail.userName = true;
                        }
                        if (error.code === 90020) {
                            me.fail.nickName = true;
                            me.fail.userName = true;
                        }
                        (me.$refs.studentForm as any).validate();
                    }
                });
            }
        });
    }
    // 选择性别
    chooseTeacherSex(value: any) {
        this.formStudent.sex = value;
    }
    // 使用默认密码
    useDefaultPassword() {
        this.formStudent.password = '123456';
    }
    // 学校管理员权限
    changeRole(checked: boolean) {
        this.formStudent.isSchoolAdmin = checked;
    }
    // 账号有效期
    changeStudentRadio(e: any) {
        if (e.target.value == 'custom') {
            this.isSchoolValidity = false;
            this.formStudent.isDefaultExpire = false;
            this.formStudent.validStartTime = null;
            this.formStudent.expireTime = null;
        } else {
            this.isSchoolValidity = true;
            this.formStudent.isDefaultExpire = true;
            // 学校管理员有效期同学校有效期
            this.formStudent.validStartTime = this.schoolValidityStart;
            this.formStudent.expireTime = this.schoolValidityEnd;
        }
    }
    disabledDate(current: any) {
        return (current && current < moment(this.schoolValidityStart)) || current > moment(this.schoolValidityEnd).add(1, 'day');
    }
    // 学生账号有效期
    changeStudentDate(dates: any) {
        if (dates[0]) {
            this.formStudent.validStartTime = dates[0].format('YYYY/MM/DD');
            if (moment(dates[1].format('YYYY/MM/DD')) > moment(this.schoolValidityEnd)) {
                this.formStudent.expireTime = this.schoolValidityEnd;
                dates[1] = moment(this.schoolValidityEnd);
            } else {
                this.formStudent.expireTime = dates[1].format('YYYY/MM/DD');
            }
        } else {
            this.formStudent.validStartTime = null;
            this.formStudent.expireTime = null;
        }
        // 手动校验有效期
        (this.$refs.studentForm as any).validateField('validStartTime', (valid: any) => {
            if (!!valid === false) {
                console.log('error...........');
                return;
            }
        });
    }
    //===================================methods区域end
    created() {
        this.isSchoolValidity = true;
        let schoolInfo: any = JSON.parse(window.localStorage.getItem('schoolInfo') as string);
        if (schoolInfo) {
            this.formStudent.schoolId = schoolInfo._id;
            this.schoolValidityStart = schoolInfo.validStartTime;
            this.schoolValidityEnd = schoolInfo.expireTime;
        }
        if (this.studentType == '班级管理-新增') {
            let newForm = this.editStudent;
            this.formStudent.period = newForm.periodValue;
            this.formStudent.grade = newForm.gradeValue;
            this.formStudent.classId = newForm.name;
            this.formStudent.validStartTime = schoolInfo.validStartTime;
            this.formStudent.expireTime = schoolInfo.expireTime;
        }
        if (this.studentType == '班级管理-编辑') {
            let newForm = this.editStudent;
            this.formStudent.nickname = newForm.nickname;
            if (newForm.sex != null) {
                this.formStudent.sex = newForm.sex.toString();
            } else {
                this.formStudent.sex = 'null';
            }
            this.formStudent.username = newForm.username;
            this.formStudent.password = newForm.password;
            this.formStudent.period = newForm.periodValue;
            this.formStudent.grade = newForm.gradeValue;
            this.formStudent.classId = newForm.name;
            if (!newForm.isDefaultExpire) {
                this.isSchoolValidity = false;
                this.formStudent.isDefaultExpire = false;
                this.formStudent.validStartTime = newForm.validStartTime;
                this.formStudent.expireTime = newForm.expireTime;
                this.isOverdueStudent = moment(newForm.expireTime.replace(/\//g, '-')).diff(moment(), 'day') < 0;
            } else {
                this.isSchoolValidity = true;
                this.formStudent.validStartTime = this.schoolValidityStart;
                this.formStudent.expireTime = this.schoolValidityEnd;
            }
            this.formStudent._id = newForm._id;
        }
    }
    mounted() {
        if (this.studentType == '编辑') {
            let editForm: any = this.editStudent;
            this.formStudent.nickname = editForm.nickname;
            if (editForm.sex == 0 || editForm.sex) {
                this.formStudent.sex = editForm.sex.toString();
            } else {
                this.formStudent.sex = 'null';
            }
            this.formStudent.username = editForm.username;
            this.formStudent.password = editForm.password;
            // this.formStudent.mobile = editForm.mobile;
            if (!editForm.isDefaultExpire) {
                this.isSchoolValidity = false;
                this.formStudent.isDefaultExpire = false;
                this.formStudent.validStartTime = editForm.validStartTime;
                this.formStudent.expireTime = editForm.expireTime;
                this.isOverdueStudent = moment(editForm.expireTime.replace(/\//g, '-')).diff(moment(), 'day') < 0;
            } else {
                this.isSchoolValidity = true;
                this.formStudent.validStartTime = this.schoolValidityStart;
                this.formStudent.expireTime = this.schoolValidityEnd;
            }
            this.formStudent._id = editForm._id;
        }
    }
}
